<div>
    <pdf-viewer [src]="data.url" [render-text]="true" [original-size]="true" style="width: 850px; height: 1100px"></pdf-viewer>
</div>
  